import packageJson from '../package.json';

export const APP_VERSION = `v${packageJson.version}`;
export const SERVER_TIMEZONE = 'Asia/Karachi';
export const BASE_URL = process.env.REACT_APP_BASE_URL
    ? process.env.REACT_APP_BASE_URL
    : 'http://72.167.133.235:3000';
export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://72.167.133.235:8080';
export const ENV_SITE_DEV = process.env.REACT_APP_SITE_DEV ? String(process.env.REACT_APP_SITE_DEV).toLowerCase() == 'true' : false;
export const LAST_SYSTEM_UPDATE_DATETIME = '18-Jun-2025 (3:33 PM)';
export const APP_ENV = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'dev';
export const SITE_LANGUAGES = {
    3: 'en',
    4: 'es',
    5: 'fr',
};

export const tbDiagnosisTypes = {
    'cxr_symptoms_tb': 1, // data enter here if it is presumtive
    'cxr_abnormal_not_tb': 2,
    'symptoms_cxr_normal': 3, // data enter here if it is clinical presumtive
    'cxr_normal_no_symptoms': 4
};

export const MTB_RESULTS_TYPE = {
    42: 'not_detected',
    43: 'detected_high',
    44: 'detected_medium',
    45: 'detected_low',
    46: 'detected_very_low',
    47: 'detected_trace',
    48: 'error',
    112: 'rejected'
};

export const RR_RESULTS_TYPE = {
    49: 'not_detected',
    50: 'detected',
    51: 'Indeterminate',
};

export const TS_TBPOC_RESULTS = {
    55: 'Detected',
    56: 'Not Detected',
    123: 'Invalid/No Result',
};

export const TS_TBCL_RESULTS = {
    57: 'Detected',
    58: 'Not Detected',
};

export const permissionTypes = {
    'static': 1,
    'dynamic': 2
};

export const ODD_TYPES = {
    87: "Asthma",
    88: "COPD",
    119: "Normal"
};

export const PERMISSIONS = {
    // Permissions grouped by resource, each with allowed actions
    users: {
        action: {'write': 'users:write', 'read': 'users:read', 'update': 'users:update', 'delete': 'users:delete', 'list': 'users:list'},
        permissions: ['users:read', 'users:write', 'users:update', 'users:delete', 'users:list'],
        description: 'User management permissions'
    },
    roles: {
        actions: {'write': 'roles:write', 'read': 'roles:read', 'update': 'roles:update', 'delete': 'roles:delete', 'list': 'roles:list', 'assign_permissions': 'roles:assign_permissions'},
        permissions: ['roles:read', 'roles:write', 'roles:update', 'roles:delete', 'roles:list', 'roles:assign_permissions'],
        description: 'Role management permissions'
    },
    permission: {
        actions: {'write': 'permissions:write', 'read': 'permissions:read', 'update': 'permissionsupdate', 'delete': 'permissions:delete', 'list': 'permissions:list'},
        permissions: ['permissions:read', 'permissions:write', 'permissions:update', 'permissions:delete', 'permissions:list'],
        description: 'Permission management permissions'
    },
    metadata: {
        actions: {'write': 'metadata:write', 'read': 'metadata:read', 'update': 'metadata:update', 'delete': 'metadata:delete', 'list': 'metadata:list'},
        permissions: ['metadata:read', 'metadata:write', 'metadata:update', 'metadata:delete', 'metadata:list'],
        description: 'Metadata permissions'
    },
    acfActivity: {
        actions: {'write': 'acf_activity:write', 'read': 'acf_activity:read', 'update': 'acf_activity:update', 'delete': 'acf_activity:delete', 'list': 'acf_activity:list'},
        permissions: ['acf_activity:read', 'acf_activity:write', 'acf_activity:update', 'acf_activity:delete', 'acf_activity:list'],
        description: 'ACF Activity permissions'
    },
    qualitative: {
        actions: {'write': 'qualitative:write', 'read': 'qualitative:read', 'update': 'qualitative:update', 'delete': 'qualitative:delete', 'list': 'qualitative:list'},
        permissions: ['qualitative:read', 'qualitative:write', 'qualitative:update', 'qualitative:delete', 'qualitative:list'],
        description: 'Qualitative permissions'
    }
}